"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var react_helmet_1 = require("react-helmet");
require("./Projects.css");
var Projects = function () { return (React.createElement("section", { className: "page-section masthead mb-0", id: "projects" },
    React.createElement("div", { className: "container" },
        React.createElement("h2", { className: "page-section-heading text-center text-uppercase text-secondary mb-0" }, "Projects"),
        React.createElement("div", { className: "divider-custom" },
            React.createElement("div", { className: "divider-custom-line" }),
            React.createElement("div", { className: "divider-custom-icon" },
                React.createElement("i", { className: "fas fa-star" })),
            React.createElement("div", { className: "divider-custom-line" })),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-lg-8 mx-auto" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-xs-12" },
                        React.createElement("h3", null, "Snake"),
                        React.createElement("p", null, "Simple snake JavaScript game."),
                        React.createElement("canvas", { id: "myCanvas", width: "507", height: "601" })))))),
    React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { src: "./legacy/snake.js", type: "text/javascript" })))); };
exports.default = react_redux_1.connect()(Projects);
//# sourceMappingURL=Projects.js.map